module.exports = __webpack_public_path__ + "static/media/illinois.36256483.png";